<template>
  <b-container>
    <b-row align-h="start" class="mb-4">
      <b-overlay :show="loading" no-wrap fixed></b-overlay>
      <b-col>
        <h1 v-if="order">Order #{{ order.number }}</h1>
      </b-col>
      <b-col class="text-right">
        <saved-notice v-if="saved" />
        <b-button
          class="mb-1 ml-2"
          variant="primary"
          @click="$router.push('/orders')"
        >
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-tabs
      v-if="order"
      nav-wrapper-class="nav-wrapper-class"
      content-class="mt-3"
      active
    >
      <b-tab title="Order Details">
        <order-details :order="order" @saved="onSave" />
      </b-tab>
      <b-tab title="Payments & Refunds">
        <order-payment :order="order" @refund-issued="onRefundIssued" />
      </b-tab>
      <b-tab title="History">
        <orderHistory :order="order" :order-placed="order.placed" />
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import ResourceAPI from '../../services/ResourceAPI';
import SavedNotice from '../../components/SavedNotice';
import orderDetails from './orderDetails.vue';
import orderPayment from './orderPayment.vue';
import orderHistory from './orderHistory.vue';

export default {
  name: 'Order',
  components: {
    orderDetails,
    orderPayment,
    orderHistory,
    SavedNotice,
  },
  data() {
    return {
      loading: false,
      order: null,
      logistics: [],
      saved: false,
      orderFields: [
        {
          key: 'id',
          label: 'Order ID',
          sortable: false,
        },
        {
          key: 'name',
          label: 'Customer',
          sortable: false,
        },
        {
          key: 'subtotal',
          label: 'Amount',
          sortable: false,
          class: 'text-right',
        },
      ],
    };
  },
  mounted() {
    this.loadOrder();
  },
  methods: {
    loadOrder() {
      this.loading = true;
      return ResourceAPI.getRecords(`network-orders/${this.$route.params.id}`, {
        with: [
          'user',
          'address.building',
          'network',
          'fulfillmentCenterOrders.orderItems',
          'fulfillmentCenterOrders.fulfillmentCenter',
          'facility',
          'payment',
          'networkOrderRefunds',
          'networkOrderRefunds.orderItemRefunds',
          'networkOrderRefunds.fulfillmentCenterOrderRefunds',
          'orderCoupons',
        ].join(','),
        appends: ['facilityReadyTime', 'kitchenReadyTime'].join(','),
      })
        .then((data) => {
          this.order = data.data;
          this.loading = false;
        })
        .catch((error) => alert(error));
    },
    onSave() {
      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 5000);
      this.loadOrder();
    },
    onRefundIssued() {
      this.loadOrder();
    },
  },
};
</script>
